export const emitterCreateSubscriber = (emitter) => (event) => (handler) => {
    emitter.on(event, handler);
    return () => {
        emitter.off(event, handler);
    };
};
export const emitterCreateDispatcher = (emitter) => (event, opts) => (payload) => {
    emitter.emit(event, payload);
    if (opts?.interceptors) {
        for (const interceptor of opts.interceptors) {
            interceptor(payload);
        }
    }
};
